import { api } from '@/apis';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useDeleteRadio() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => {
      if (id) {
        return api.delete(`radios/${id}`);
      }
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['radios'] }),
  });
}
